import { isDashboardApp } from "@/core/services/domain.service";
import initDashboardVueApp from "@/apps/dashboard/main";
import initWhiteLabelWebsiteVueApp from "@/apps/whiteLabelWebsite/main";

(() => {
  isDashboardApp() ? initDashboardVueApp() : initWhiteLabelWebsiteVueApp();
})();
